

































































import { Component, Prop, Mixins } from "vue-property-decorator";
import { mapState } from "vuex";
import { FilteringSortingTableStore } from "@/mixins/tableWithFilteringAndSortingStore";
import Context from "@/mixins/context";
import { DataModules } from "@/store/modules/data";
import { Sorters } from "@/data/table";
import { ITableConfig } from "@/models/tables";
import { IPhone } from "@/models/phones";
import { IState } from "@/store";
import { IClient } from "@/models/clients";

@Component({
  computed: {
    ...mapState({
      params(state: IState, getters) {
        return getters[`data/${this.dataModule}/params`](this.clientId);
      }
    })
  }
})
export default class ClientPhonesTable extends Mixins(
  FilteringSortingTableStore,
  Context
) {
  // Getters
  public params!: object;

  @Prop({ required: true })
  public clientId!: IClient["id"];

  @Prop({ default: null })
  public countryCode!: string;

  @Prop({ default: false })
  public isStaged!: boolean;

  public dataModule: string = DataModules.CLIENTS_PHONES;

  public defaults: ITableConfig = {
    page: 1,
    limit: 0,
    sort: {
      field: "default,created_at",
      direction: Sorters.DESCENDING
    },
    filters: []
  };

  public created() {
    if (this.isClient || this.$userCan("list_client_phones")) {
      this.dataPayloadSettings = { id: this.clientId };
      this.getData();
    } else {
      this.loading = false;
    }
  }

  public editPhone(phone: IPhone) {
    return this.$store.dispatch(`data/${this.dataModule}/openEditModal`, {
      countryCode: this.countryCode,
      phone
    });
  }

  public makeDefault(phone: IPhone) {
    return this.$store
      .dispatch(`data/${this.dataModule}/makeDefault`, {
        phone
      })
      .then(async (onSuccess?: boolean) => {
        if (onSuccess) await this.refreshList();
      });
  }

  public deletePhone(phone: IPhone) {
    return this.$store.dispatch(`data/${this.dataModule}/confirmDelete`, {
      phone,
      onConfirm: this.refreshList
    });
  }

  public getFullPhoneNumber(phone: IPhone) {
    return `${this.$_.get(phone, "phone_code", "")} ${this.$_.get(
      phone,
      "phone",
      ""
    )}`;
  }

  public refreshList() {
    return this.getData({ ignoreStored: true });
  }
}
